document.addEventListener('DOMContentLoaded', function () {
    if (activeDiscounts.length>0 && activeDiscounts[0].percent) {
        console.log("[Discount Apply] Active code:", activeDiscounts[0].name, "| Discount:", activeDiscounts[0].percent + "%");

        // If no Compare Prices
        const basicPrices = document.querySelectorAll('.price__regular .price-item--regular');

        // If Compare Prices exist
        const comparePrices = document.querySelectorAll('.price__sale .price-item--regular');
        const salePrices = document.querySelectorAll('.price__sale .price-item--sale');
  
        comparePrices.forEach((comparePriceEl, index) => {
            let originalText = comparePriceEl.textContent.trim();
            // First scenario with Compare and Sale Prices 
            if (originalText!="") {
                // Detect currency symbol and decimal separator
                const currencySymbolMatch = originalText.match(/[€$]/);
                const decimalSeparator = originalText.includes(',') ? ',' : '.';
                const currencySymbol = currencySymbolMatch ? currencySymbolMatch[0] : '';

                // Parse price by normalizing separator to dot for JS
                const numericString = originalText.replace(/[^0-9,\.]/g, '').replace(',', '.');
                const originalPrice = parseFloat(numericString);

                if (!isNaN(originalPrice)) {
                    const newPrice = (originalPrice * ((100 - activeDiscounts[0].percent ) / 100)).toFixed(2);

                    // Format new price using the original decimal separator
                    const newFormatted = currencySymbol + newPrice.replace('.', decimalSeparator);

                    if (salePrices[index]) {
                    salePrices[index].textContent = newFormatted;
                    }
                }
            }
            // 2nd scenario without Compare Prices 
            else{
                let originalText = basicPrices[index].textContent.trim();
                // Detect currency symbol and decimal separator
                const currencySymbolMatch = originalText.match(/[€$]/);
                const decimalSeparator = originalText.includes(',') ? ',' : '.';
                const currencySymbol = currencySymbolMatch ? currencySymbolMatch[0] : '';

                // Parse price by normalizing separator to dot for JS
                const numericString = originalText.replace(/[^0-9,\.]/g, '').replace(',', '.');
                const originalPrice = parseFloat(numericString);

                if (!isNaN(originalPrice)) {
                    const newPrice = (originalPrice * ((100 - activeDiscounts[0].percent ) / 100)).toFixed(2);

                    // Format new price using the original decimal separator
                    const newFormatted = currencySymbol + newPrice.replace('.', decimalSeparator);

                    if (comparePrices[index] && salePrices[index]) {
                       comparePrices[index].textContent = originalText;
                       salePrices[index].textContent = newFormatted;
                       salePrices[index].parentElement.style.display = "block";
                       salePrices[index].closest('.price').classList.add('price--on-sale');
                    }
                }
            }
        });
    } else {
        console.log("[Discount Apply] No Price Element or valid product discount code found.");
    }
});
